import { initialState as settingsInitialState, version as settingsVersion } from "./settings";
import { createTransform } from "redux-persist";

const SettingsTransform = createTransform(
  (inboundState) => inboundState,
  (outboundState) =>
    outboundState.version === settingsVersion ? outboundState : settingsInitialState,
  { whitelist: ["settings"] }
);

export default SettingsTransform;
